import { makeStyles } from "tss-react/mui"
import { Grid, Skeleton, Stack } from "@mui/material"
import { StandardDialog } from "../../../../../shared/components/dialogs/StandardDialog"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import {
    fetchSupportPrinterQueueDetails,
    SupportPrinterQueueDetailsResponse,
    SupportReportsPrinterQueueQuery,
} from "../printerQueueApi"

const useStyles = makeStyles()(() => ({
    container: { padding: "1rem" },
}))

export type RawReceiptDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    id: number
}>

function transformData(data: SupportPrinterQueueDetailsResponse) {
    return data?.printerQueueDetails || []
}

export function RawReceiptDialog({ open, onClose, id }: RawReceiptDialogProps) {
    const { classes } = useStyles()

    const { data, isLoading } = useApiQuery(fetchSupportPrinterQueueDetails, {
        queryName: SupportReportsPrinterQueueQuery.DETAILS_PRINTER_QUEUE_FOR_SUPPORT,
        dependencies: {
            printerQueueId: id,
        },
        select: transformData,
    })

    return (
        <StandardDialog dialogTitle={<></>} open={open} onClose={onClose} maxWidthProp="sm">
            {isLoading ? (
                <Grid container className={classes.container}>
                    <Stack width="100%" direction="column" spacing="1rem">
                        <Skeleton variant="rectangular" animation="wave" />
                        <Skeleton variant="rectangular" animation="wave" />
                        <Skeleton variant="rectangular" animation="wave" />
                    </Stack>
                </Grid>
            ) : (
                <Grid container className={classes.container}>
                    {data?.content}
                </Grid>
            )}
        </StandardDialog>
    )
}
